export default "__VITE_ASSET__DNvoKni5__"